/**
 * 自動コマ配置ページVO
 *
 * @export
 * @class PlanGoodsBaseModel
 * @extends {Array<any>}
 */
export class PlanGoodsBaseModel extends Array<any> {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 部門分類管理NO
  public classDivNum: string = <string>'';

  // 包材一括表示フラグ
  public packMaterialShowFlg: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';

  // 大分類コード
  public largeClassCode: string = <string>'';

  // 中分類コード
  public middleClassCode: string = <string>'';

  // 小分類コード
  public smallClassCode: string = <string>'';

  // データ種別
  public dataType: string = <string>'';

  // 商品案内用商品名
  public guideGoodsName: string = <string>'';

  // 商品案内用規格名
  public guideStandardName: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  /**
   * Ｐコード基本
   */
  // お届け明細用商品名（漢字）
  public deliveryGoodsNameKanji: string = <string>'';

  // お届け明細用規格名（漢字）
  public deliveryStandardNameKanji: string = <string>'';

  // お届け明細用商品名（カナ）
  public deliveryGoodsNameKana: string = <string>'';

  // お届け明細用規格名（カナ）
  public deliveryStandardNameKana: string = <string>'';

  // ＯＣＲ商品名
  public ocrGoodsName: string = <string>'';

  // 消費税区分
  public consumeTaxDiv: string = <string>'';

  // 消費税率
  public consumeTaxRate: string = <string>'';

  // サイクル期間
  public cycleTerm: string = <string>'';

  // ＥＤＬＰ商品区分
  public edlpDiv: string = <string>'';

  // ユニットプライス区分
  public unitPriceDiv: string = <string>'';

  // ユニットプライス係数
  public unitPriceCoefficient: string = <string>'';

  // ユニットプライス単位
  public unitPriceUnit: string = <string>'';

  // 賞味期間
  public consumeTerm: string = <string>'';

  // 消費期限
  public consumeByDate: string = <string>'';

  // 残賞味期間（配達時）
  public leaveConsumeTerm: string = <string>'';

  // 商品室内温度帯区分
  public guideTempZoneDiv: string = <string>'';

  // 関連Ｐコード（旧）
  public relationPCodeOld: string = <string>'';

  // 関連Ｐコード（新）
  public relationPCodeNew: string = <string>'';

  // 目隠し区分
  public blindDiv: string = <string>'';

  // ｅフレンズ送信要否
  public eFriendsSendDiv: string = <string>'';

  // 項番1808 START
  // コマ配置予定区分
  public komaScheduleDiv: string = <string>'';
  // 項番1808 END

  // 酒類コード
  public liquorCode: string = <string>'';

  // アルコール分別
  public alocoholType: string = <string>'';

  // 容器形態
  public containerForm: string = <string>'';

  // 容器容量
  public containerCapacity: string = <string>'';

  /**
   * Ｐコード詳細情報
   */
  // 表組用商品名
  public listingGoodsName: string = <string>'';

  /**
   * Ｐコード付加情報
   */
  // バイヤーコメント
  public buyerComment: string = <string>'';

  /**
   * Ｐコード発注物流
   */
  // 臭い商品区分
  public StinkGoodsDiv: string = <string>'';

  // ケース供給区分
  public CaseSupplyDiv: string = <string>'';

  // 長期保存区分
  public LongKeepDiv: string = <string>'';

  // 入荷場所区分
  public ArrivalAreaDiv: string = <string>'';

  // 入荷許可品温
  public ArrivalGoodsTemp: string = <string>'';

  // 入荷管理日数
  public ArrivalAdminDays: string = <string>'';

  // 項番1215 START
  // 業態区分（デイリー）
  public DutiesFormDailyDiv: string = <string>'';
  // 業態区分（スポット）
  public DutiesFormSpotDiv: string = <string>'';
  // 項番1215 END

  /**
   * Ｐコード計画数
   */
  // 計画数（総数）
  public planNumTotal: string = <string>'';

  /**
   * 抽選商品プロモーション
   */
  // 抽選商品プロモーションフラグ
  public lotteryPromotionFlg: number = <number>null;
  // ポイント交換商品プロモーションフラグ
  public pointPromotionFlg: number = <number>null;
  // 1物N価媒体プロモーションフラグ
  public nvalPromotionFlg: number = <number>null;
  // クーポン商品プロモーションフラグ
  public couponPromotionFlg: number = <number>null;
  // 在庫限定フラグ
  public stockLimitFlg: number = <number>null;
  // 予約媒体フラグ
  public preOrderFlg: number = <number>null;
  // 通常媒体フラグ
  public regularFlg: number = <number>null;
}
